<template>
  <b-button @click.stop="onClick" class="add-button button" variant="success">
    <slot>Add item</slot>
  </b-button>
</template>

<script>
export default {
  props: {
    onClick: Function
  }
}
</script>

<style lang="scss" scoped>
.add-button {
  flex-grow: 1;
  justify-content: center;
  margin: -8px 10px -8px 0;
  text-transform: uppercase;
}
</style>
